import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  noteText: {
    fontSize: theme.typography.body2.fontSize,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2)
  } as SxProps,

  confirmButtonContainer: {
    marginTop: theme.spacing(2)
  } as SxProps
}

export default styles
